import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './util/config.service';

export type PassportAccessTokenResponse = { access_token: string };

@Injectable({ providedIn: 'root' })
export class PassportService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);

  private passportServiceKey = this.configService.config.serviceKey?.passport || '';
  private styleServiceKey = this.configService.config.serviceKey?.style || '';
  private passportUrl = this.configService.config.passportUrl;
  private passportApiUrl = this.configService.externalApiConfig.passportUrl;

  getLoginLink(backwardsUrl = '/'): string {
    const encRedirectUrl = encodeURIComponent(window.location.origin);
    const encBackwardsUrl = encodeURIComponent(backwardsUrl);

    let url = `${this.passportUrl}?service_key=${this.passportServiceKey}&backwards_url=${encBackwardsUrl}&redirect_url=${encRedirectUrl}`;

    if (this.styleServiceKey) {
      url += `&style_service_key=${this.styleServiceKey}`;
    }

    return url;
  }

  updateUserToken(): Observable<PassportAccessTokenResponse> {
    const headers = new HttpHeaders({
      service_key: this.passportServiceKey,
    });

    return this.http.post<PassportAccessTokenResponse>(
      `${this.passportApiUrl}/api/v1/internal_auth/auth/update_token/`,
      null,
      {
        headers,
      }
    );
  }
}
